export default __webpack_public_path__ + "static/media/fa-angle-up_hover.6d8e9311.png";